import type { FC } from "react";

import styled from "styled-components";

import { EmptyState } from "@similarweb/ui-components";

import type { SubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import { translate } from "app/filters/i18nFilter";
import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import LOBLegends from "../../../components/LOBLegends";

import HorizontalBarList from "./HorizontalBarList";
import useVisitsBreakdownSingleMode from "./useVisitsBreakdownSingleMode";

const ChartContainer = styled(FlexRow)`
    padding: 24px;
    gap: 24px;
    width: 100%;
`;

const StyledEmptyState = styled(EmptyState)`
    width: 100%;
`;

interface IVisitsBreakdownSingleModeProps {
    subtitleFilters: SubtitleFilters;
}

const VisitsBreakdownSingleMode: FC<IVisitsBreakdownSingleModeProps> = ({ subtitleFilters }) => {
    const { allChartData, legendItems, setLegendItems, visibleChartData, isLoading } = useVisitsBreakdownSingleMode();

    const numOfSelectedLobs = visibleChartData.filter((item) => !item.isTotal).length;

    const columnTitles: [string, string] = [
        translate("analysis.content.lob.legend.title.value.line.of.business"),
        translate("analysis.content.lob.legend.title.value.visits"),
    ];
    return (
        <WidgetContainer
            data-automation="visits-breakdown-widget"
            title={translate("analysis.content.visits.breakdown.title")}
            tooltip={translate("analysis.content.visits.breakdown.tooltip")}
            subtitleFilters={subtitleFilters}
            withBorder
            isLoading={isLoading}
            noData={!allChartData.length}
            showSubtitleFiltersLoadingState={false}
            loaderHeight={360}
            loaderWidth="100%"
        >
            <FlexRow>
                <ChartContainer>
                    {numOfSelectedLobs ? (
                        <HorizontalBarList
                            legendItems={legendItems}
                            data={visibleChartData}
                        />
                    ) : (
                        <StyledEmptyState
                            title=""
                            subtitle={translate("analysis.content.lob.no.data")}
                        />
                    )}
                    {legendItems.length > 1 ? (
                        <LOBLegends
                            legendItems={legendItems}
                            setLegendItems={setLegendItems}
                            height="250px"
                            eventName="total visits"
                            hasSearch={true}
                            columnTitles={columnTitles}
                        />
                    ) : null}
                </ChartContainer>
            </FlexRow>
        </WidgetContainer>
    );
};

export default VisitsBreakdownSingleMode;
